import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Image, Sparkles, ArrowRight } from "lucide-react";
import { apiClient } from "../lib/api";
import type { ListingDraft } from "@erc/shared";

export default function ListingBuilderListPage() {
  const { data: projects, isLoading } = useQuery({
    queryKey: ["builder-projects"],
    queryFn: () => apiClient.listBuilderProjects(),
  });

  return (
    <div className="mx-auto max-w-5xl p-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <Sparkles className="h-6 w-6 text-indigo-500" />
          Design Builder
        </h1>
        <p className="mt-1 text-sm text-gray-500">
          Mağaza analizinden ürünleri ekle, AI ile yeni varyasyonlar tasarla
        </p>
      </div>

      {isLoading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-48 animate-pulse rounded-xl bg-gray-100" />
          ))}
        </div>
      ) : !projects || projects.length === 0 ? (
        <div className="flex flex-col items-center justify-center rounded-2xl border-2 border-dashed border-gray-200 py-16">
          <Image className="mb-3 h-12 w-12 text-gray-300" />
          <p className="text-gray-500 mb-1">Henüz proje yok</p>
          <p className="text-xs text-gray-400">
            Mağaza analizinde bir ürünün fotoğrafına tıklayıp &quot;Listeye Ekle&quot; butonunu kullan
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {projects.map((p: ListingDraft) => (
            <Link
              key={p.id}
              to={`/design-builder/${p.id}`}
              className="group rounded-xl border border-gray-200 bg-white overflow-hidden shadow-sm hover:shadow-md hover:border-indigo-200 transition-all"
            >
              {p.sourceImageUrl ? (
                <img
                  src={p.sourceImageUrl}
                  alt=""
                  className="h-40 w-full object-cover bg-gray-50"
                />
              ) : (
                <div className="flex h-40 items-center justify-center bg-gray-50">
                  <Image className="h-10 w-10 text-gray-300" />
                </div>
              )}
              <div className="p-3">
                <p className="text-sm font-medium text-gray-900 line-clamp-2 group-hover:text-indigo-600">
                  {p.title}
                </p>
                <div className="mt-2 flex items-center justify-between">
                  <span className="text-xs text-gray-400">
                    {p.designVariations?.length ?? 0} varyasyon
                  </span>
                  <ArrowRight className="h-4 w-4 text-gray-400 group-hover:text-indigo-500" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
